const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024
const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf']
const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'application/pdf']

export type UploadValidationReason = 'size' | 'type' | 'jpeg'

export type UploadValidationResult = {
  isValid: boolean
  error?: string
  reason?: UploadValidationReason
}

export function validateUploadFile (file: File): UploadValidationResult {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      isValid: false,
      reason: 'size',
      error: 'File size is too large. The maximum file size is 20MB.'
    }
  }

  const extension = getFileExtension(file.name)
  const mimeType = file.type
  const extensionOk = ALLOWED_EXTENSIONS.includes(extension)
  const mimeOk = mimeType === '' || ALLOWED_MIME_TYPES.includes(mimeType)

  if (!extensionOk || !mimeOk) {
    const isNonJpegImage = mimeType.startsWith('image/') &&
      !['image/jpeg', 'image/png'].includes(mimeType)

    return {
      isValid: false,
      reason: isNonJpegImage ? 'jpeg' : 'type',
      error: 'Unsupported file type. Please upload .jpg, .png, or .pdf files.'
    }
  }

  return { isValid: true }
}

function getFileExtension (fileName: string): string {
  const lastDot = fileName.lastIndexOf('.')
  if (lastDot < 0) return ''
  return fileName.slice(lastDot).toLowerCase()
}
